'use client';

import { useState } from 'react';
import { ArchivalLabelCard } from 'components/collection/archival-label';
import ObjectGrid from 'components/collection/object-grid';
import { ArchivalLabelViewer } from '.';
import { type IObjectAsLauderArchivalLabel } from '@metmuseum/types';

interface IProps {
	enforceMaxObjectWidth: boolean;
	archivalLabels: IObjectAsLauderArchivalLabel[];
}

export const ArchivalLabelsWithViewer = ({
	archivalLabels,
	enforceMaxObjectWidth,
}: IProps) => {
	const [showObjectViewer, setShowObjectViewer] = useState(false);
	const [activeObjectIndex, setActiveObjectIndex] = useState(0);

	const handleObjectClick = (e, index) => {
		e.preventDefault();
		setShowObjectViewer(true);
		setActiveObjectIndex(index);
	};

	const handleCloseClick = () => setShowObjectViewer(false);

	return (
		<div>
			<ObjectGrid>
				{archivalLabels?.map((archivalLabel, index) => {
					return (
						<ArchivalLabelCard
							index={index}
							enforceMaxWidth={enforceMaxObjectWidth}
							handleObjectClick={handleObjectClick}
							key={archivalLabel.archivalLabelID}
							archivalLabel={archivalLabel}
						/>
					);
				})}
			</ObjectGrid>
			{showObjectViewer && (
				<ArchivalLabelViewer
					archivalLabels={archivalLabels}
					initialActiveObjectIndex={activeObjectIndex}
					handleCloseClick={handleCloseClick}
				/>
			)}
		</div>
	);
};
